import type { ReviewSeverity } from '@/lib/conversationReviews.ts';

/** The rungs the Messages page marks, worst first. */
export type AttentionSeverity = Extract<ReviewSeverity, 'critical' | 'high' | 'medium'>;

export const ATTENTION_ORDER: readonly AttentionSeverity[] = [
  'critical',
  'high',
  'medium',
];

/* The tone each rung is drawn in, shared by the count badge and the notes. */
export const ATTENTION_TONES: Record<AttentionSeverity, 'danger' | 'warning' | 'info'> = {
  critical: 'danger',
  high: 'warning',
  medium: 'info',
};

/*
 * Medium and up asks for somebody's attention. Anything below it — and any rung
 * this console does not know yet, such as a lower one added later — does not.
 */
export function needsAttention(severity: string): severity is AttentionSeverity {
  return (ATTENTION_ORDER as readonly string[]).includes(severity);
}
